import { registerModal } from 'features/Modal/ModalRegistry'
import InternetFormModal from './InternetFormModal'
import { showModal } from 'features/Modal/Modal.actions'

export const modalType = 'INTERNET_FORM_MODAL'
registerModal(modalType, InternetFormModal)
export default modalProps =>
  showModal({
    modalType,
    modalProps,
    modalOptions: {
      fullScreen: true,
    },
  })



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Internet/InternetFormModal/InternetFormModal.action.js